import React, { Component } from 'react';
import BootstrapModal from '../../themes/streamlined/Modal';

const PopupError = function(props) {
    let errorName = (props && props.error && props.error.friendly && props.error.friendly.name) ? props.error.friendly.name : 'Unknown Error';
    let errorDesc = (props && props.error && props.error.friendly && props.error.friendly.description) ? props.error.friendly.description : 'An unknown error occured and was not properly handled.';
    let modalDesc = <p>{errorDesc}</p>
    let closeFunction = props.closeFunction ? props.closeFunction : () => {document.location.reload()};
    let closeText = props.closeText ? props.closeText : 'Close';
    return (
        <BootstrapModal bodyContent={modalDesc} title={errorName} proceedFunction={props.proceedFunction} proceedText={props.proceedText} closeFunction={closeFunction} closeText={closeText}/>
    )
};
export default PopupError;